import { render, staticRenderFns } from "./MedicineUsageWay.vue?vue&type=template&id=20de596a&scoped=true&"
import script from "./MedicineUsageWay.vue?vue&type=script&lang=js&"
export * from "./MedicineUsageWay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20de596a",
  null
  
)

export default component.exports